import React from 'react'
import Resume from '../../assets/AlisaGulamhusseinResume.pdf'

const CTA = () => {
  return (
    <div className='cta'>
        <a href={Resume} download className='btn' data-aos="zoom-in" data-aos-duration="2000">Resume</a>
        <a href="#contact" className='btn btn-primary' data-aos="zoom-in" data-aos-duration="2000">Contact Me</a>
    </div>
  )
}

export default CTA